






































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import { mapState } from 'vuex';
import QuestionGroupFormFields from './partials/QuestionGroupFormFields.vue';
import QuestionList from './partials/QuestionList.vue';
// import QuestionGroupPreview from "./partials/QuestionGroupPreview.vue"
import { STATUSES } from '@/constants/question_group';

@Component({
  components: {
    QuestionGroupFormFields,
    QuestionList,
    // QuestionGroupPreview,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('QuestionGroup', {
      questionGroup: 'questionGroup',
    }),
  },
})
export default class QuestionGroupUpdate extends Mixins(CRUDMixins) {
  loading!: boolean;
  questionGroup!: Model;

  isMounted = false;
  isLoading = false;
  isApiFetch = {
    isApiFetchQuestionGroupFinished: false,
    isApiFetchRiskProfileItemFinished: false,
    isApiFetchCandidateProfileFinished: false,
    isApiFetchBodySystemsFinished: false,
  };

  // isPreviewActive = false

  tab = 0;
  statuses = STATUSES;

  mounted() {
    // Fetch question group with impacted targets and library relationship
    this.$store
      .dispatch('QuestionGroup/fetch', {
        objectId:
          this.questionGroup.object_id ?? this.$route.params.questionGroupOid,
        config: {
          params: {
            expand: ['impacted_targets', 'library'],
          },
        },
      })
      .then(() => {
        this.preventPrevVer();
        this.isApiFetch['isApiFetchQuestionGroupFinished'] = true;
      });

    this.$store.dispatch('RiskProfileItem/fetchList').then(() => {
      this.isApiFetch['isApiFetchRiskProfileItemFinished'] = true;
    });
    this.$store
      .dispatch('CandidateProfile/fetchCandidateProfileItems')
      .then(() => {
        this.isApiFetch['isApiFetchCandidateProfileFinished'] = true;
      });
    this.$store.dispatch('BodySystem/fetchList').then(() => {
      this.isApiFetch['isApiFetchBodySystemsFinished'] = true;
    });
  }

  beforeDestroy() {
    this.$store.commit('QuestionGroup/CLEAR_STATE');
  }

  markAsDraft() {
    // Update question group title and description
    this.isLoading = true;
    this.$store
      .dispatch('QuestionGroup/update', {
        objectId: this.questionGroup.object_id,
        config: {
          ...this.questionGroup,
          status: 'STATUS_DRAFT',
        },
      })
      .then(() => {
        this.preventPrevVer();

        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'The question group is saved successfully.',
        });
      })
      .catch((error) => {
        this.isLoading = false;
        const errorMessages = Object.keys(error.response.data.error)
          .map((key) => error.response.data.error[key])
          .join();
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: errorMessages,
        });
      });
  }

  save() {
    // Update question group title and description
    this.isLoading = true;
    this.$store
      .dispatch('QuestionGroup/update', {
        objectId: this.questionGroup.object_id,
        config: {
          ...this.questionGroup,
        },
      })
      .then(() => {
        this.preventPrevVer();

        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'The question group is saved successfully.',
        });
      })
      .catch((error) => {
        this.isLoading = false;
        const errorMessages = Object.keys(error.response.data.error)
          .map((key) => error.response.data.error[key])
          .join();
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: errorMessages,
        });
      });
  }

  publish() {
    this.isLoading = true;
    this.$store
      .dispatch('QuestionGroup/update', {
        objectId: this.questionGroup.object_id,
        config: {
          ...this.questionGroup,
          status: 'STATUS_PUBLISHED',
        },
      })
      .then(() => {
        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'The question group is saved successfully.',
        });
      })
      .catch(({ error }) => {
        this.$store.commit('SET_LOADING', false);
        console.debug(error);
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: 'The question group is saved as draft successfully.',
        });
      });
  }

  preventPrevVer() {
    if (this.questionGroup.object_id !== this.$route.params.questionGroupOid) {
      this.$router.push(
        {
          name: 'administrator-question-group-update',
          params: {
            questionGroupOid: this.questionGroup.object_id as string,
          },
        },
        () => {
          this.$router.go(0);
        }
      );
    }
  }

  @Watch('loading')
  watchLoading(newVal) {
    if (!newVal) {
      this.$tabEvent.emit(
        'reload-preview-' + this.$route.params.questionGroupOid
      );
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }
}
